import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignatureComponent } from 'components/signature/signature.component';

@Component({
  selector: 'cm-employer-request-modal',
  templateUrl: './employer-request-modal.component.html',
  styleUrls: ['./employer-request-modal.component.scss'],
})
export class EmployerRequestModalComponent {
  @Input() agreement_text: string;
  @Input() requestedBy: string;
  @Input() requestedByImage: string;

  termsAccepted = false;
  error: string;

  constructor(public modalService: NgbActiveModal) {}

  acceptRequest(signature: SignatureComponent) {
    if (this.isFormValid(signature)) {
      this.modalService.close(signature.signature);
    }
  }

  private isFormValid(signature: SignatureComponent): boolean {
    this.error = null;
    const signatureError = signature.getSignatureErrors();

    if (!this.termsAccepted) {
      this.error = 'Agreement text is not accepted';
      return false;
    } else if (signatureError) {
      this.error = signatureError;
      return false;
    } else {
      return true;
    }
  }
}
